<template>
  <div>
    <b-card>
      <div slot="header">
        <div class="row d-flex">
          <strong size="md">Liste des clients</strong>
        </div>
        <!--<b-btn :disabled="!readyForPrinting" class="float-right" size="sm" variant="outline-success" v-on:click="printClients">
        Imprimer
      </b-btn>-->
    </div><!-- header -->
    <table class="table table-bordered table-striped table-sm" style="width=100%;">
      <thead>
        <tr>
          <th></th><th>Nom</th><th>Prénom</th><th>Adresse</th><th></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="client in clients" v-bind:client="client">
          <tr>
            <td style="cursor: pointer" v-on:click="edit(client.id)"><i class="fa fa-edit"/></td>
            <td>{{ client.surname }}</td>
            <td>{{ client.name }}</td>
            <td>{{ client.street }} {{ client.cp }} {{ client.town }}</td>
            <td style="cursor: pointer" v-on:click="removeCustomer(client.id, client.surname)"><i class="fa fa-trash-o"/></td>
          </tr>
          <tr>
            <td colspan="3" style="text-align:right;">{{ client.comment }}</td>
            <td colspan="2" style="text-align:right;">{{ client.email }} / {{ client.landline }} / {{ client.gsm }}</td>
            <td></td>
          </tr>
        </template>
      </tbody>
    </table>
  </b-card>
  <!-- modal to display error -->
  <b-modal size="lg" ok-only v-model="showModalError">
    <span v-html="lastError"></span>
  </b-modal>
</div><!-- whole page -->
</template>

<script>
import store from '@/store'
import router from '@/router'
// import _ from 'lodash'

export default {
  name: 'listing',
  data: function () {
    return {
      consoleOutput: true, // debug
      clients: [], // commandes à produire
      showModalError: false,
      lastError: '',
      date: '',
      opened: [],
      displaySpinner: true,
      detailRef: '',
      readyForPrinting: false,
      src: ''
    }
  },
  beforeCreate () {
    if (!store.state.isLogged) {
      router.push('/')
    }
  },
  created () {
    // debug
    // this.rangeStart.setDate(this.rangeStart.getDate() - 40)
    // this.rangeEnd.setDate(this.rangeStart.getDate() + 100)
    // debug end
    this.fetchClients()
  },
  methods: {
    onRangeModified () {
      // reget data
      this.fetchClients()
    },
    fetchClients () {
      this.$Progress.start()
      this.clients = []
      this.$http.get(process.env.API_URL + '/customer/list').then((response) => {
        var clientList = response.body.Customers
        this.serverDate = response.body.date
        if (this.consoleOutput) {
          console.log('got ' + Object.keys(clientList).length + ' customers')
        }
        for (var c in clientList) {
          if (clientList[c].cp === 0) {
            clientList[c].cp = ''
          }
          this.clients.push(clientList[c])
        }
        this.$Progress.finish()
      },
      (error) => {
        this.$Progress.fail()
        this.clients = []
        if (error.status === 403) {
          this.$eventHub.$emit('redirectToLogin')
        }
      })
      this.$Progress.finish()
      this.$Progress.start()
    },
    printClients () {
      if (this.consoleOutput) {
        console.log('print clients')
      }
      var base64EncodedPDF = this.src
      var downloadLink = document.createElement('a')
      // downloadLink.target = '_blank'
      downloadLink.download = 'clients.pdf'
      // convert downloaded data to a Blob
      var blob = new Blob([base64EncodedPDF], {type: 'application/pdf'})
      // create an object URL from the Blob
      var URL = window.URL || window.webkitURL
      var downloadUrl = URL.createObjectURL(blob)
      // set object URL as the anchor's href
      downloadLink.href = downloadUrl
      // append the anchor to document body
      document.body.append(downloadLink)
      // fire a click event on the anchor
      downloadLink.click()
      // cleanup: remove element and revoke object URL
      document.body.removeChild(downloadLink)
      URL.revokeObjectURL(downloadUrl)
    },
    removeCustomer (id, name) {
      this.$Progress.start()
      var req = {'id': id}
      // if (this.consoleOutput) {
      console.log('remove client ' + id)
      // }
      this.$http.get(process.env.API_URL + '/customer/delete', {params: req}).then((response) => {
        this.fetchClients()
        this.$notify({
          group: 'main',
          title: 'Suppression client',
          text: 'Client ' + id + ' supprimé.',
          duration: 5000
        })
        this.$Progress.finish()
      },
      (error) => {
        console.log(error)
        this.$notify({
          group: 'main',
          title: 'Suppression client',
          text: 'Impossible de supprimer le client ' + id + ' (' + name + '), il est lié à une commande.',
          duration: 5000,
          type: 'error'
        })
        this.$Progress.fail()
      })
    },
    // function call on "modify" button
    edit (id) {
      console.log('edit client ' + id)
      router.push({name: 'Edition de client', params: { id: id }})
    }
  }
}
</script>
<style>
.CellWithComment{position:relative;}
.CellComment{
  visibility: hidden;
  width: auto;
  position:absolute;
  z-index:100;
  text-align: center;
  opacity: 0.4;
  border-radius: 6px;
  border-color: red;
  border-style: solid;
  background-color: #FEFEFE;
  padding:3px;
  top:30px;
  left:0px;
}
.CellWithComment:hover span.CellComment {visibility: visible;opacity: 1}
</style>



// WEBPACK FOOTER //
// Clients.vue?c93ab75e